import { Bell } from 'lucide-react'
import { ActionPopover } from './wrappers/ActionPopover'
import { NotificationsContent } from './content/NotificationsContent'
import { useGetSwapsQuery } from '../../generated/graphql'
import { FilterStatus } from '@valiant/ui-shared'
import { useNavigation } from '../../contexts/NavigationContext'
import { usePendingAddresses } from '../../hooks/usePendingAddresses'

interface NotificationsPopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onMobileClick?: () => void
  isActive?: boolean
}

export function NotificationsPopover({
  open,
  onOpenChange,
  onMobileClick,
  isActive,
}: NotificationsPopoverProps) {
  const { selectedGroupId } = useNavigation()

  // Query for pending (requested) swaps only to get the count for the badge
  const [{ data: swapsData }] = useGetSwapsQuery({
    variables: {
      filter: {
        //@ts-expect-error - This is a temporary fix to allow the status to be set to Awaiting
        status: FilterStatus.Awaiting,
        groupId: selectedGroupId,
      },
    },
    requestPolicy: 'network-only',
  })

  // Get pending addresses count for the selected group
  const { count: pendingAddressesCount } = usePendingAddresses(selectedGroupId)

  const pendingSwapsCount = swapsData?.getSwaps.nodes?.length || 0
  const totalCount = pendingSwapsCount + pendingAddressesCount

  return (
    <ActionPopover
      open={open}
      onOpenChange={onOpenChange}
      trigger={
        <div className="relative">
          <Bell className="w-8 h-8" />
          {totalCount > 0 && (
            <div className="absolute -top-2 -right-2 bg-red-500 text-white text-xs rounded-full w-6 h-6 flex items-center justify-center">
              {totalCount > 99 ? '99+' : totalCount}
            </div>
          )}
        </div>
      }
      onMobileClick={onMobileClick}
      isActive={isActive}
    >
      <NotificationsContent />
    </ActionPopover>
  )
}
